import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './routes';
import './plugins/vuetify';
import './plugins/calendar';
import device from 'current-device';
import Vuex from 'vuex'
import {baseStore} from './store';
import * as env from './settings/env';
import * as sd from './services/session-data'
import UiHeader from './components/UI/header.vue';
import * as firebase from "firebase";
import { firebaseConfig } from '@/settings/env';
import VueGtag from "vue-gtag";
import * as $gtag from "vue-gtag";
import PWAUtils, * as pwa from '@/registerServiceWorker'

// tslint:disable-next-line: no-var-requires
// const device = require('current-device').default;

firebase.initializeApp(firebaseConfig);
PWAUtils.register();

Vue.config.productionTip = false;

Vue.component('UiHeader', UiHeader);

Vue.use(Vuex);
export const store = new Vuex.Store(baseStore);

var lu = sd.getLocalUser();
lu.subscribe(user => {
  let userId = '';
  let nome_usuario = '';
  if (user) {
    userId = user.idLogin;
    nome_usuario = user.nome;
  } 
  
  Vue.use(VueGtag, {
    config: { 
      id: env.gAnalyticsID, 
      params: {'user_id': userId}
    },
    onReady() {
      $gtag.customMap({ 'dimension1': 'nome_usuario' });
      $gtag.event('nome_usuario', { nome_usuario });
    },
    
  }, router);
});

var infiniteScroll =  require('vue-infinite-scroll');
Vue.use(infiniteScroll)

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
